import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { CmsDeviceSettings } from '@nsftx/seven-client-retail-vue-sgp'

export const useServiceModeStore = defineStore('serviceMode', () => {
  const serviceMode = ref(false)

  const setServiceMode = (value: boolean) => {
    serviceMode.value = value
  }

  const syncFromDeviceSettings = (deviceSettings: CmsDeviceSettings) => {
    setServiceMode(!!deviceSettings.serviceMode)
  }

  const toggleServiceMode = () => {
    setServiceMode(!serviceMode.value)
  }

  return {
    serviceMode,
    setServiceMode,
    syncFromDeviceSettings,
    toggleServiceMode
  }
})
